import { render, staticRenderFns } from "./Cajones.vue?vue&type=template&id=45e00e14&"
import script from "./Cajones.vue?vue&type=script&lang=js&"
export * from "./Cajones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports